import SnoozedPage from './snoozedPage.view';

export default SnoozedPage;
